import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import createInfo from "../Purchase.module.css";

import StyleInfo from "../../../BookModule.module.css";
import Select, { components } from "react-select";
import { Download, Label, Search } from "@mui/icons-material";
import Creatable from "react-select/creatable";
import toast from "react-hot-toast";
import moment from "moment";
import ViewIcon from "../ViewIcon.png";
import { customStyles } from "../../../../../../../pages/customStyles";
// import Loader from "../../../../Loader";
import { Chip, Paper, styled } from "@mui/material";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../../../labels";
import { AxiosInstance } from "../../../../../../../axios";
import Loader from "../../../../../Loader";
import DatePicker_book from "../../../DatePicker_book";
import DatePickerSample from "../../../../../DatePicker";

export default function AddNewCourierDetails() {
  const { id } = useParams();
  const location = useLocation();
  // labelStatus - 1 - courier - 0 -picup
  const { ORDERPK, purchase_id, labelStatus, courierType, addressData } =
    location.state || {};

  const [purchaseId, setPurchaseId] = useState(
    location.state?.purchase_id || null
  );
  useEffect(() => {
    setPurchaseId(purchase_id);
  }, []);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  let page = R_PER_PAGE;
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [author_name, setAuthor_name] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [initialfields, setInitialfields] = useState({
    origin: "",
    orderId: "",
    pickupId: "",
    pickup_date: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [updateListData, setUpdateListData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [barcode, setBarcode] = useState("");

  const [error, setError] = useState({});
  const [updateChipData, setUpdateChipData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    author: false,
    publisher: false,
    visible_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    seriesTag: false,
  });
  const [series_on, setSeries_on] = useState([]);
  let filterAuthor = [];
  const Tagsitems = [
    {
      tag_id: 0,
      tag_name: "A",
    },
    {
      tag_id: 1,
      tag_name: "B",
    },
    {
      tag_id: 2,
      tag_name: "GB",
    },
    {
      tag_id: 3,
      tag_name: "QB",
    },
    {
      tag_id: 4,
      tag_name: "PYQ",
    },
    // {
    //   tag_id: 6,
    //   tag_name: "Combo Offers",
    // },
  ];
  useEffect(() => {
    filterSeries = series_on;
  }, [series_on]);
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    if (!id) {
      loadListdata();
    }
  }, []);

  // Ref

  const type_order_id = useRef(null);
  // const type_pickup_id = useRef(null);
  const type_tracking_id = useRef(null);
  // const type_pick_date = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const filterRef_series = useRef(null);
  let filterSearch = [];
  let filterSeries = [];
  const [originalListData, setOriginalListData] = useState([]);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      AxiosInstance.post("/api/book/delivered_books_view", {
        id: parseInt(id),
        order_pk: ORDERPK,
      })
        .then((res) => {
          if (res.data.status) {
            setIsLoading(false);
            const fiata = res.data.data;
            setInitialfields((prevState) => ({
              ...prevState,
              origin: res.data.courier_details.origin,
              orderId: res.data.courier_details.courier_id,
            }));
            const serialNumberAddedData = fiata.map((data, index) => ({
              ...data,
              serialNumber: index + 1,
            }));
            setOriginalListData(fiata);
            setUpdateListData(serialNumberAddedData);
            setSelectedBookIds(
              fiata
                .map((er) => er.is_selected === 1 && er.id)
                .filter((id) => id !== null)
            );
          } else if (res.data.status === false) {
            setUpdateListData([]);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setUpdateListData([]);
          setIsLoading(false);
          return error;
        });
    }
  }, [id]);

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "seriesTag") {
      if (checked) {
        setSeries_on([
          ...series_on,
          { id: value, name: name, type: "seriesTag" },
        ]);
      } else {
        setSeries_on(series_on.filter((item) => item.id !== value));
      }
    }
  };
  function loadChipdata() {
    let tempArr = [];
    filterSeries.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleApplyFilter = (name, event) => {
    // updateStateData();
    if (name === "seriesTag") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        seriesTag: false,
      });
      setUpdateListData(
        updateListData.filter((item) =>
          series_on.some((series) => Number(series.id) === item.series_id)
        )
      );
    }
  };
  const handleClear = (name) => {
    if (name === "seriesTag") {
      setSeries_on([]);
      filterSeries = [];
    }
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "seriesTag") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        seriesTag: !prevState.seriesTag, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
      }));
      setSeries_on(updateChipData.filter((ui) => ui.type === "seriesTag"));
    }
  };
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };
  const [selectedBookIds, setSelectedBookIds] = useState([]);
  const [bookItems, setBookItems] = useState([]);
  const handleChangeBookOrder = (e, bookId, books) => {
    const isChecked = e.target.checked;
    setBookItems((prev) => {
      if (isChecked) {
        return [...prev, books];
      } else {
        return prev.filter((id) => id !== bookId);
      }
    });
    setSelectedBookIds((prev) => {
      if (isChecked) {
        return [...prev, bookId];
      } else {
        return prev.filter((id) => id !== bookId);
      }
    });
  };

  const loadListdata = () => {
    AxiosInstance.post("api/book/delivered_add_bookslist", {
      id: parseInt(purchase_id ? purchase_id : purchaseId),
    })
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);

          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  };

  function updateStateData() {
    filterAuthor = author_name;
    filterSeries = series_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  const handleDelete = (chipToDelete, index) => () => {
    loadListdata();
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "seriesTag") {
      setSeries_on(series_on.filter((item) => item.id !== chipToDelete.id));
      filterSeries = series_on.filter((item) => item.id !== chipToDelete.id);
    }
    loadChipdata();
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    //  loadListdata();
  };

  const validateFocusCommentSection = (COMSECFO, STAT) => {
    if (!COMSECFO.orderId && labelStatus == 1) {
      type_order_id.current.focus();
    }
    // if (!COMSECFO.pickupId && labelStatus == 0) {
    //   type_pickup_id.current.focus();
    // }
    else if (!COMSECFO.origin && STAT == 1) {
      type_tracking_id.current.focus();
    }
    // else if (!COMSECFO.pickup_date && STAT == 0) {
    //   type_pick_date.current.setFocus();
    // }
  };

  const validateFields = (data, stat) => {
    const errors = {};
    if (!data.orderId && labelStatus == 1) {
      errors.orderId = "Please enter AWB number";
    }
    // if (!data.pickupId && labelStatus == 0) {
    //   errors.pickupId = "Please enter pickup id ";
    // }

    const isbnRegex = /^\d{11}$/;
    if (data.orderId && !isbnRegex.test(data.orderId)) {
      errors.orderId = "Please enter a valid 11-digit AWB number";
    }

    if (!data.origin && labelStatus == 1) {
      errors.origin = "Please enter origin source";
    }
    // if (!data.pickup_date && stat == 0) {
    //   errors.pickup_date = "Please choose date";
    // }
    validateFocusCommentSection(data, stat);
    return errors;
  };

  const handleSubmit = () => {
    const err_bnh = validateFields(initialfields, labelStatus);

    if (Object.keys(err_bnh).length === 0) {
      try {
        if (id) {
          let updateCoupon;
          updateCoupon = {
            id: parseInt(id),
            order_id: parseInt(purchase_id ? purchase_id : purchaseId),
            delivery_type: labelStatus == 1 ? 1 : 0,
            items_ids:
              selectedBookIds.length > 0 ? selectedBookIds.join(",") : "",
            tracking_id: initialfields.origin,
            courier_id: initialfields.orderId,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };
          AxiosInstance.post(`api/book/delivered_books`, updateCoupon)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);
                navigate(
                  `/ViewPurchase/${purchase_id ? purchase_id : purchaseId}`
                );
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          let updateCoupon;
          updateCoupon = {
            id: "",
            order_id: parseInt(purchase_id ? purchase_id : purchaseId),
            delivery_type: labelStatus == 1 ? 1 : 0,
            items_ids:
              selectedBookIds.length > 0 ? selectedBookIds.join(",") : "",
            tracking_id: initialfields.origin,
            courier_id: initialfields.orderId,
            // created_dt:
            //   labelStatus === 1
            //     ? moment().format("YYYY-MM-DD HH:mm:ss")
            //     : initialfields?.pickup_date
            //       ? moment(initialfields.pickup_date, "DD/MM/YYYY").format(
            //         "YYYY-MM-DD HH:mm:ss"
            //       )
            //       : "",
            created_dt: moment(new Date(), "DD/MM/YYYY").format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            created_by: userid,
            // Courier list
            awbno: initialfields?.orderId,
            refno: "123456",
            orginsrc: initialfields?.origin,
            frmname: "AIASA",
            frmadd1: "48, Vanigar theru, Kanchipuram",
            frmadd2: "",
            frmpincode: "607802",
            frmphone: "9876543216",
            toname: addressData?.name || "",
            toadd1: addressData?.address || "",
            toadd2: "",
            toarea: "",
            topincode: addressData?.pincode || "",
            tophone: addressData?.phone_no || "",
            goodsname: "kayboard",
            goodsvalue: "",
            doctype: "D",
            transmode: "S",
            qty: bookItems.reduce((sum, item) => sum + item.quantity, 0) || "",
            weight: bookItems.reduce((sum, item) => sum + item.weight, 0) || "",
            volweight: "",
            topayamt: "",
            codamt: "",
            invfiletype: "",
            invcopy: "",
          };
          setIsLoading(true);

          AxiosInstance.post(`api/book/delivered_books`, updateCoupon)
            .then((res) => {
              setIsLoading(false);

              if (res.data.status) {
                toast.success(res.data.message);
                navigate(
                  `/ViewPurchase/${purchase_id ? purchase_id : purchaseId}`
                );
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "orderId") {
      const regex = /^\d{11}$/; // Match exactly 10 or 13 digits
      if (regex.test(value)) {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "",
        });
      } else {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setError({
          ...error,
          [name]: "Please enter a valid 11-digit AWB number",
        });
      }
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const handleViewBOOK = (IDS, bookId, type, courierType) => {
    const label = id
      ? "Back to Edit Courier Details"
      : `${
          labelStatus == 1
            ? "Back to New Courier Details"
            : "Back to New Pickup Details"
        }`;

    navigate(`/viewIndividualBook/${IDS}`, {
      state: { LABEL: label },
    });

    // if (type == 1) {
    //   navigate(`/studyMaterials/Books/ViewBookSet/${bookId}/${IDS}`, {
    //     state: { LABEL: label },
    //   });
    // } else {
    //   navigate(`/viewIndividualBook/${IDS}`, {
    //     state: { LABEL: label },
    //   });
    // }
  };
  const handlepickupDate = (date, name) => {
    const dateEYD = moment(date).format("DD/MM/YYYY");
    setInitialfields((prevState) => ({
      ...prevState,
      [name]: dateEYD,
    }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.
  const currentData = updateListData?.slice(start, end);

  const handleScan = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      const scannedBarcode = event.target.value.trim();
      // const isNumeric = /^\d+$/.test(scannedBarcode);

      if (!scannedBarcode) {
        toast.error("No book found for the given ISBN number");
        console.error("No book found for the given ISBN number");
        setBarcode("");
        return;
      }

      // if (scannedBarcode.length < 10 || scannedBarcode.length > 13) {
      //   toast.error("No book found for the given ISBN number");
      //   setBarcode("");
      //   return;
      // }

      setBarcode(scannedBarcode);

      const foundBooks = currentData.filter(
        (book) =>
          String(book.isbn_no).toLowerCase() ===
          String(scannedBarcode).toLowerCase()
      );

      if (foundBooks.length === 0) {
        toast.error("No book found for the given ISBN number");
        setBarcode("");
        return;
      }

      setSelectedBookIds((prevIds) => {
        const newIds = foundBooks
          .map((book) => book.id)
          .filter((id) => !prevIds.includes(id));

        if (newIds.length > 0) {
          const updatedIds = [...new Set([...prevIds, ...newIds])];
          toast.success("Selected successfully");
          return updatedIds;
        } else {
          toast.error("Book already selected");
          return prevIds;
        }
      });

      setBarcode("");
    }
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id
              ? "Edit Courier Details"
              : `${
                  labelStatus == 1
                    ? "Add New Courier Details"
                    : "Add New Pickup Details"
                }`}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "javascript:void(0)"}
                onClick={
                  id ? navigateToPreviousScreen : navigateToPreviousScreen
                }
                className="secondaryButton "
                variant="secondary"
              >
                {id ? `Back to View Courier Details` : "Back to View Sales"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={selectedBookIds.length == 0 ? () => {} : handleSubmit}
                className={`primaryButton text-center ${
                  selectedBookIds.length == 0 && "disabled_btn"
                }`}
                variant="primary"
              >
                {id
                  ? "Save Courier Details"
                  : `${
                      labelStatus == 1
                        ? "Save Courier Details"
                        : "Save Pickup Details"
                    }`}
              </Link>
            </li>
          </ul>
        </div>
        {/*  Select Books*/}
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Select Books</legend>
            <div className="col-md-3 col-12 mt-3">
              <div className={StyleInfo.searchInputSec}>
                {/* Prevent form submission from reloading */}
                <input
                  className={`${StyleInfo.searchInput} w-100`}
                  type="text"
                  placeholder="Scan barcode here..."
                  name="bar_code_search"
                  autoFocus
                  value={barcode}
                  onChange={(e) => setBarcode(e.target.value)} // Update state normally
                  onKeyDown={handleScan}
                />
              </div>
            </div>

            <div className="row mb-3">
              {updateChipData?.length > 0 ? (
                <div className="row mt-3">
                  <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {updateChipData.map((data, index) => {
                        let icon;
                        return (
                          <ListItem key={index}>
                            <Chip
                              icon={icon}
                              label={
                                <>
                                  <span className={StyleInfo.BoldTyText}>
                                    {data.name}
                                  </span>
                                </>
                              }
                              onDelete={handleDelete(data, index)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row mx-0 mt-4">
                <div className="col-md-12 table-responsive tableMinHeight px-0 ">
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th" className={StyleInfo.tableThPadding}></th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "serialNumber")}
                            className="textHead_th"
                          >
                            S.No.
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "serialNumber")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className="textHead_th"
                          >
                            Book Name
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "author")}
                            className="textHead_th"
                          >
                            Author
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "author")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          {/* <span
                            className={`textHead_th align-middle material-icons ${
                              author_name.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.author ? StyleInfo.active_icons_book : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "author")}
                          >
                            filter_list
                          </span>
                          {isOpen.author && (
                            <>
                              <div className="filterBoxs_testlist mt-5">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {/* {auData.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.author_name}
                                        value={el.author_id}
                                        id={el.author_name}
                                        checked={author_name.some((element) => {
                                          if (element.id == el.author_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.author_name,
                                            "author"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.author_name}
                                      >
                                        {el.author_name}
                                      </label>
                                    </li>
                                  ))} *
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("author")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          author_name.length === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("author")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div
                                ref={filterRef_author}
                                className={`${StyleInfo.overlayBookFilter} ${
                                  isOpen.author ? "active" : ""
                                }`}
                              ></div>
                            </>
                          )} */}
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "publisher")}
                            className="textHead_th"
                          >
                            Publisher
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "publisher")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          {/* <span
                            className={`textHead_th align-middle material-icons ${
                              publisher_name.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.publisher
                                ? StyleInfo.active_icons_book
                                : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "publisher")}
                          >
                            filter_list
                          </span>
                          {isOpen.publisher && (
                            <>
                              <div className="filterBoxs_testlist mt-5">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {/* {pubData.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.publisher_name}
                                        value={el.publisher_id}
                                        id={el.publisher_name}
                                        checked={publisher_name.some(
                                          (element) => {
                                            if (element.id == el.publisher_id) {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.publisher_name,
                                            "publisher"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.publisher_name}
                                      >
                                        {el.publisher_name}
                                      </label>
                                    </li>
                                  ))} 
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("publisher")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          publisher_name.length === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("publisher")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div
                                ref={filterRef_publisher}
                                className={`${StyleInfo.overlayBookFilter} ${
                                  isOpen.publisher ? "active" : ""
                                }`}
                              ></div>
                            </>
                          )} */}
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className="textHead_th"
                          >
                            Bookset Name
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">
                            No. of <br /> Books
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>

                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "category_name")}
                            className="textHead_th"
                          >
                            Category
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "category_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className="textHead_th"
                          >
                            Course
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className="textHead_th"
                          >
                            Subject
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "medium")}
                            className="textHead_th"
                          >
                            Medium
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "medium")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_series}
                        >
                          <span
                            className="textHead_th"
                            onClick={(e) => handleSort(e, "seriesTag")}
                          >
                            Book Series
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => handleSort(e, "seriesTag")}
                          >
                            import_export{" "}
                          </span>
                          {/* <span
                            className={`textHead_th align-middle material-icons ${series_on.length > 0 ? StyleInfo.active_icons_book : ""
                              } ${isOpen.seriesTag ? StyleInfo.active_icons_book : ""}`} // Change here
                            onClick={(e) => handleFilter(e, "seriesTag")}
                          >
                            filter_list
                          </span>
                          {isOpen.seriesTag && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">

                                    {Tagsitems.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.tag_name}
                                          value={el.tag_id}
                                          id={el.tag_name}
                                          checked={series_on.some((element) => {
                                            if (element.id == el.tag_id) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          onChange={(e) =>
                                            handleCheckboxChange(
                                              e,
                                              el.tag_name,
                                              "seriesTag"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.tag_name}
                                        >
                                          {el.tag_name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("seriesTag")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={series_on.length === 0 ? true : false}
                                        onClick={() => handleApplyFilter("seriesTag")}
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div
                                ref={filterRef_series}
                                className={`${StyleInfo.overlayBookFilter} ${isOpen.medium ? "active" : ""
                                  }`}
                              ></div>
                            </>
                          )} */}
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "set_name")}
                            className="textHead_th"
                          >
                            Individual / Bookset
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "set_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        {/* Delivery Status */}
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            className="textHead_th"
                            onClick={(e) => handleSort(e, "delivery_status")}
                          >
                            Delivery Status
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "delivery_status")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "price")}
                            className="textHead_th"
                          >
                            MRP
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "price")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "offer_percentage")}
                            className="textHead_th"
                          >
                            Offer %
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "offer_percentage")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            class="textHead_th"
                          >
                            Final <br /> Price
                          </span>

                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Action</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData?.length === 0 ? (
                        <tr>
                          <td colspan="15" style={{ textAlign: "center" }}>
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        // Table Body
                        currentData?.map((book) => (
                          <tr
                            key={book.id}
                            className={
                              book.stock_status == 1 ? StyleInfo.redRow : ""
                            }
                          >
                            <td>
                              {id && (
                                <input
                                  className={`${StyleInfo.checkBox_input}`}
                                  type="checkbox"
                                  name="bookset_order"
                                  id={`bookset_order_${book.id}`}
                                  value={book.id}
                                  checked={selectedBookIds.includes(book.id)}
                                  disabled={book.is_pre_order === 1}
                                  onChange={(e) => {
                                    handleChangeBookOrder(e, book.id, book);
                                  }}
                                />
                              )}

                              {!id && (
                                <input
                                  className={`${StyleInfo.checkBox_input}`}
                                  type="checkbox"
                                  name="bookset_order"
                                  id={`bookset_order_${book.id}`}
                                  checked={selectedBookIds.includes(book.id)}
                                    disabled={book.is_pre_order === 1}
                                  onChange={(e) => {
                                    handleChangeBookOrder(e, book.id, book);
                                  }}
                                />
                              )}
                            </td>
                            <td id="td">{book.serialNumber}</td>
                            <td id="td">
                              <span
                                title={book.book_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.book_name || "_"}
                              </span>
                            </td>
                            <td id="td">
                              {" "}
                              <span
                                title={book.author}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.author ? book.author : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={book.publisher}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.publisher ? book.publisher : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={book.set_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.set_name || "_"}
                              </span>
                            </td>
                            <td id="td">
                              {book.quantity ? book.quantity : "_"}
                            </td>

                            <td id="td">
                              {book.category_name ? book.category_name : "_"}
                            </td>
                            <td id="td">
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </td>
                            <td id="td">
                              <span
                                title={book.subject_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.subject_name || "_"}
                              </span>
                            </td>
                            <td id="td">{book.medium ? book.medium : "_"}</td>
                            <td id="td">{book.series_name || "_"}</td>
                            {/* Individal bookset */}
                            <td id="td">
                              {book.is_set == 0 ? "Individual" : "Bookset"}
                            </td>
                            <td id="td">{book.delivery_status || "_"}</td>
                            {/*                             
                            {book.delivery_status == 0 && (
                              <td id={`${StyleInfo.td}`}>
                                <span class="filterChipText bg-pink">
                                  Pickup Pending
                                </span>
                              </td>
                            )}
                            {book.delivery_status == 1 && (
                              <td id={`${StyleInfo.td}`}>
                                <span class="filterChipText bg-orange">
                                  Shipping in Progress
                                </span>
                              </td>
                            )}
                            {book.delivery_status == 2 && (
                              <td id={`${StyleInfo.td}`}>
                                <span class="filterChipText bg-green">
                                  Delivered
                                </span>
                              </td>
                            )} */}
                            <td id="td">{book.price ? book.price : "_"}</td>
                            <td id="td">
                              {book.offer_percentage
                                ? book.offer_percentage
                                : "0"}
                            </td>
                            <td id="td">
                              {book.final_price ? book.final_price : "_"}
                            </td>
                            <td id="td">
                              <img
                                onClick={() =>
                                  handleViewBOOK(
                                    book.book_id,
                                    book.book_ids,
                                    book.is_set,
                                    courierType
                                  )
                                }
                                src={ViewIcon}
                                className={StyleInfo.cursor_pointer}
                                alt="view icon"
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPage}
                  handlePageCount={handlePageCount}
                  startPage={
                    updateListData && updateListData?.length > 0
                      ? currentPage * rowsPerPage + 1 - rowsPerPage
                      : 0
                  }
                  endPage={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length < currentPage * rowsPerPage
                        ? updateListData?.length
                        : currentPage * rowsPerPage
                      : 0
                  }
                  totalRecords={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length
                      : 0
                  }
                  handlePrev={(e) => handlePrev(currentPage - 1)}
                  currentPrevPage={currentPage === 1}
                  prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                  handleNext={() => handleNext(currentPage + 1)}
                  currentNextPage={
                    currentPage === totalPages || totalPages == 0
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
        {/* Courier Details */}
        {labelStatus == 1 && (
          <div className="mb-4">
            <fieldset className="mt-3">
              <legend className="w-auto">Courier Details</legend>
              <>
                <form className="row g-3">
                  <div class="col-md-6">
                    <label for="CouponCode" class="form-label confirm_value ">
                      AWB Number
                    </label>
                    <input
                      ref={type_order_id}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm
                      `}
                      type="number"
                      id="orderId"
                      name="orderId"
                      placeholder="Enter the AWB Number"
                      value={initialfields.orderId}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                    />
                    {error.orderId && (
                      <small className="error_message">{error.orderId}</small>
                    )}
                  </div>
                  <div class="col-md-6">
                    <label for="origin" class="form-label confirm_value ">
                      Origin Source
                    </label>
                    <input
                      ref={type_tracking_id}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm
                      `} //new style added
                      // isDisabled={id ? true : false}
                      type="text"
                      id="origin"
                      name="origin"
                      placeholder="Enter the origin source"
                      value={initialfields.origin}
                      onChange={handleChange}
                    />
                    {error.origin && (
                      <small className="error_message">{error.origin}</small>
                    )}
                  </div>
                </form>
              </>
            </fieldset>
          </div>
        )}
        {/* {labelStatus == 0 && (
          <div className="mb-4">
            <fieldset className="mt-3">
              <legend className="w-auto">Pickup Details</legend>
              <>
                <form className="row g-3">
                  <div class="col-md-6">
                    <label for="CouponCode" class="form-label confirm_value ">
                      Pickup ID
                    </label>
                    <input
                      ref={type_pickup_id}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm
                      `}
                      type="text"
                      id="pickupId"
                      name="pickupId"
                      placeholder="Enter the pickup id"
                      value={initialfields.pickupId}
                      onChange={handleChange}
                    />
                    {error.pickupId && (
                      <small className="error_message">{error.pickupId}</small>
                    )}
                  </div>
                  <div class="col-md-6">
                    <label for="pickup_date" class="form-label confirm_value ">
                      Date
                    </label>
                    <DatePickerSample
                      txtAdMDob={type_pick_date}
                      name={"pickup_date"}
                      handleChange={(date) =>
                        handlepickupDate(date, "pickup_date")
                      }
                      fieldInput={initialfields.pickup_date}
                      minDate={moment().startOf("day").toDate()}
                    />
                  
                    {error.pickup_date && (
                      <small className="error_message">
                        {error.pickup_date}
                      </small>
                    )}
                  </div>
                </form>
              </>
            </fieldset>
          </div>
        )} */}

        <div className="col-md-12 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "javascript:void(0)"}
                onClick={
                  id ? navigateToPreviousScreen : navigateToPreviousScreen
                }
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Courier Details" : "Back to View Sales"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={selectedBookIds.length == 0 ? () => {} : handleSubmit}
                className={`primaryButton text-center ${
                  selectedBookIds.length == 0 && "disabled_btn"
                }`}
                variant="primary"
              >
                {id
                  ? "Save Courier Details"
                  : `${
                      labelStatus == 1
                        ? "Save Courier Details"
                        : "Save Pickup Details"
                    }`}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
